import { ChangeDetectionStrategy, Component, inject } from '@angular/core';

import {
  CopyrightComponent,
  IconComponent,
  ModalComponent,
  OptionalAsyncPipe,
  WebComponentsConfigService,
} from '@evc/web-components';

import { PlatformConfigService } from '../../features/config/config.service';
import { PlatformTranslatePipe } from '../../features/i18n/platform-translate.pipe';
import { AppIdentity } from '../../features/types/app-identity.type';

@Component({
  selector: 'evc-about-modal',
  templateUrl: './about-modal.component.html',
  imports: [
    ModalComponent,
    IconComponent,
    CopyrightComponent,
    OptionalAsyncPipe,
    PlatformTranslatePipe,
  ],
  styleUrls: ['./about-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AboutModalComponent extends ModalComponent {
  readonly #webComponentConfigService = inject(WebComponentsConfigService);
  readonly #platformConfigService = inject(PlatformConfigService);

  readonly basePath = this.#webComponentConfigService.getComputed('ASSETS_BASE_PATH');
  readonly appIdentity = this.#platformConfigService.getComputed<AppIdentity>('app');
}
